import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import '../../../App.css'
// tuto ReactJS Basics YOUTUBE 
// https://www.cluemediator.com/read-csv-file-in-react 

function CsvAnita({ myFile, tabTemp, tabCH, placementlink, typeAnita }) {

  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [consol, setConsol] = useState([]);
  const [cycleID, setCycle] = useState([]);
  const [listItems, setListItems] = useState([]);

  const getTrProps = (state, rowInfo) => {
    try {
      if (rowInfo && rowInfo.row) {
        return {
          onClick: (e) => {
            this.setState({
              selected: rowInfo.index
            })
          },
          style: {
            background: rowInfo.index === this.state.selected ? '#00afec' : 'white',
            color: rowInfo.index === this.state.selected ? 'white' : 'black'
          }
        }
      } else {
        return {}
      }
    }
    catch (e) { alert('no') }
  }

  // handle file upload
  const handleFileUpload = e => {
    try {
      myFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (evt) => {
        /* Parse data */
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const list = [];
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });

        var firstData = data.split("Time,");
        placementlink = new Array(firstData[0].split("\n").length);
        var lign = firstData[0].split("\n");
       
        for (var i = 0; i < lign.length - 1; i += 1) {
          if (lign[1]==="") {
            var firstpart = lign[i].split(",");
            placementlink[i] = firstpart[0];
          }else if(lign[i].includes("ZONE")){
            
            var firstpart = lign[i].split(",");
            placementlink[i] = firstpart[0].concat(firstpart[1]).slice(1,-1);
          }
          else {
            //car les zone 1 et power sont ecrit sur la meme ligne et separe par une virgule 
            var firstpart = lign[i].split(",");
            placementlink[i] = firstpart[0].concat(firstpart[1]);
            //console.log(placementlink[i])
          }
        }
        var Z = data.split("Time,").pop();
        var x = "Time,".concat(Z);
        const b = x.split('\n');

        const column = b[0].split(',');
        tabTemp[0] = new Array(b[0].split(',').length);
        tabTemp[0] = b[0].split(',');
        //setCycle(data.split("Cycle ID :").pop().split(",")[0]);
        setCycle(placementlink)
        setListItems(placementlink.map((x) =>
          <div>&nbsp;{x}<br /> </div>
        ))

        setConsol(data.split("Console S/N :").pop().split(",")[0]);
        for (let i = 1; i < b.length; i++) {
          var current = b[i].split(',');
          tabTemp[i] = new Array(b[0].split(',').length);
          tabTemp[i] = b[i].split(',');
          const obj = {};
          tabCH[i - 1] = new Array(4);
          var max = -1;
          var min = 999;
          var max2 = -1;
          var min2 = 999;
          for (let j = 0; j < current.length; j++) {

            tabTemp[i][j] = tabTemp[i][j] * 1;
            // Convert input string to a number and store as a variable.
            var value = Number(tabTemp[i][j] * 1);
            // Split the input string into two arrays containing integers/decimals
            try {
              var res = tabTemp[i][j].split(".");
              if (res.length == 1 || res[1].length < 3) {
                // Set the number to two decimal places
                value = value.toFixed(1);
              }
            }
            catch (e) {
              value = value.toFixed(1);
            }
            // If there is no decimal point or only one decimal place found.

            tabTemp[i][j] = value; //pour enlever les zéros de guauche
            if (tabTemp[0][14] == 'TC13') {
              if (max < value && j <= 13 && j > 1) {
                max = value;
              }
              if (min > value && j <= 13 && value != 0 && j > 1) {
                min = value;
              }
              tabCH[i - 1][0] = max;
              tabCH[i - 1][1] = min;
              if (max2 < value && j < 26 && j > 13) {
                max2 = value;
              }
              if (min2 > value && j > 13 && j < 26 && value != 0) {
                min2 = value;
              }
              tabCH[i - 1][2] = max2;
              tabCH[i - 1][3] = min2;
            }
            else {//12 TC
              if (max < value && j <= 6 && j > 1) {
                max = value;
              }
              if (min > value && j <= 7 && value != 0 && j > 1) {
                min = value;
              }
              tabCH[i - 1][0] = max;
              tabCH[i - 1][1] = min;
              if (max2 < value && j <= 13 && j > 7) {
                max2 = value;
              }
              if (min2 > value && j > 7 && j <= 13 && value != 0) {
                min2 = value;
              }
              tabCH[i - 1][2] = max2;
              tabCH[i - 1][3] = min2;
            }

            obj[column[j]] = current[j];
          }
          list.push(obj);
        }
        setData(list);
        const columns = column.map(c => ({
          name: c,
          selector: c,
          sortable: true,


        }));
        if (tabTemp[0][14] == 'TC13')
          typeAnita[0] = "24";
        else typeAnita[0] = "12";
        typeAnita[1] = placementlink
        setColumns(columns);
        //processData(data);
      };
      reader.readAsBinaryString(myFile);

    }
    catch (error) {
      alert('Insert a file generated by Anita without any modifications.');
    }
  }
  return (
    <div className="stopwatch" >
      <br /><br /><br />
      <span style={{ width: "80%" }}>
        <h3 style={{ color: 'red' }}>Insert a CSV file generated by Anita </h3>
        
        <div className="custom-file-upload">

          <input style={{
            position: "relative",
            textAlign: "right",
            opacity: 1,
            zIndex: 2
          }}
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleFileUpload}
          /> </div>
        <div style={{ marginLeft: '5%', textAlign: 'left' }}> {listItems}</div>

        
        <br />

      </span>
    </div>
  );
}

export default CsvAnita;